var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('v-row',[_c('v-col',{staticClass:"px-0 py-1",attrs:{"cols":"12"}},[_c('v-btn',{attrs:{"block":true,"color":"warning"},on:{"click":_vm.ujGepDiszpecser}},[_vm._v(" Új Számítógép ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }